// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607271455/js/" + chunkId + "." + {"44":"4493c1bf","225":"c7e8c679","481":"84e4e1f1","486":"086e5b45","770":"1cc3a978"}[chunkId] + ".0.27250557829425626.chunk.js";
};